import { actions as sliceActions, reducer } from './slice';
import * as thunkActions from './thunks';

const actions = {
  ...sliceActions,
  ...thunkActions,
};

export { actions, reducer };
